import React from 'react';
import LoginComponent from 'components/Auth/LoginComponent';

export const OrganizationsLogin: React.FC = () => {
    return <LoginComponent />;
};

export default OrganizationsLogin;